// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper-3iYJh"};